import type { FeatureAdoptionData } from 'shared/services/feature-adoption';

export const enum FeatureAdoptionTypes {
  highDemandBtn = 1,
  saturatedZoneHDB = 2,
}

export type AdoptionData = FeatureAdoptionData<FeatureAdoptionTypes>;
